import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as fromGoal from '../actions'
import { getPatientFromMatch } from '@medeo/patients'
import { getGoalsFromPatientId } from '../ducks'
import WeightTarget from '../components/WeightTarget'
import HeartRateTarget from '../components/HeartRateTarget'
import BloodGlucoseTarget from '../components/BloodGlucoseTarget'
import KidneyTarget from '../components/KidneyTarget'
import { FormattedMessage } from 'react-intl'
import { editGoals } from '../helpers'

const EditPatientGoals = ({ patient, goals, modifyGoals }) => {
  let pathology = 'unknown'

  if (goals.length > 0) {
    pathology = goals[0].addresses[0].reference
  }
  const weightGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'bodyWeight'
  )
  const pulseGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'heartRate'
  )
  const fastingGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'fasting'
  )
  const middayGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'midday'
  )
  const eveningGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'evening'
  )
  const systolicGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'systolic'
  )
  const diastolicGoals = goals.filter(
    goal => goal.target.measure.coding[0].display === 'diastolic'
  )
  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        const { elements } = e.currentTarget
        let goals = []
        if (pathology === 'heartFailure') {
          goals = [
            ...goals,
            ...editGoals({
              verylow: elements.namedItem('bpm-verylow').value,
              low: elements.namedItem('bpm-low').value,
              high: elements.namedItem('bpm-high').value,
              veryhigh: elements.namedItem('bpm-veryhigh').value,
              description: 'heartRate',
              code: '8867-4',
              disease: pathology,
              oldGoals: pulseGoals
            }),
            ...editGoals({
              verylow: elements.namedItem('weight-verylow').value,
              low: elements.namedItem('weight-low').value,
              high: elements.namedItem('weight-high').value,
              veryhigh: elements.namedItem('weight-veryhigh').value,
              description: 'bodyWeight',
              code: '29463-7',
              disease: pathology,
              oldGoals: weightGoals
            })
          ]
        }

        if (
          pathology === 'type1Diabetes' ||
          pathology === 'type2Diabetes1Injection' ||
          pathology === 'type2DiabetesOtherSchemas'
        ) {
          goals = [
            ...goals,
            ...editGoals({
              verylow: elements.namedItem('fasting-verylow').value,
              low: elements.namedItem('fasting-low').value,
              high: elements.namedItem('fasting-high').value,
              veryhigh: elements.namedItem('fasting-veryhigh').value,
              description: 'fasting',
              code: '10450-5',
              disease: pathology,
              oldGoals: fastingGoals
            }),
            ...editGoals({
              verylow: elements.namedItem('midday-verylow').value,
              low: elements.namedItem('midday-low').value,
              high: elements.namedItem('midday-high').value,
              veryhigh: elements.namedItem('midday-veryhigh').value,
              description: 'midday',
              code: '25428-4',
              disease: pathology,
              oldGoals: middayGoals
            }),
            ...editGoals({
              verylow: elements.namedItem('midday-verylow').value,
              low: elements.namedItem('midday-low').value,
              high: elements.namedItem('midday-high').value,
              veryhigh: elements.namedItem('midday-veryhigh').value,
              description: 'evening',
              code: '25428-4',
              disease: pathology,
              oldGoals: eveningGoals
            })
          ]
        }
        if (pathology === 'kidneyFailure') {
          goals = [
            ...goals,
            ...editGoals({
              verylow: elements.namedItem('systolic-verylow').value,
              low: elements.namedItem('systolic-low').value,
              high: elements.namedItem('systolic-high').value,
              veryhigh: elements.namedItem('systolic-veryhigh').value,
              description: 'systolic',
              code: '8480-6',
              disease: pathology,
              oldGoals: systolicGoals
            }),
            ...editGoals({
              verylow: elements.namedItem('diastolic-verylow').value,
              low: elements.namedItem('diastolic-low').value,
              high: elements.namedItem('diastolic-high').value,
              veryhigh: elements.namedItem('diastolic-veryhigh').value,
              description: 'diastolic',
              code: '8462-4',
              disease: pathology,
              oldGoals: diastolicGoals
            })
          ]
        }

        modifyGoals(goals)
      }}
    >
      {pathology === 'heartFailure' && (
        <div>
          <HeartRateTarget />
          <WeightTarget />
        </div>
      )}
      {pathology === 'type1Diabetes' && <BloodGlucoseTarget />}
      {pathology === 'type2Diabetes1Injection' && <BloodGlucoseTarget />}
      {pathology === 'type2DiabetesOtherSchemas' && <BloodGlucoseTarget />}
      {pathology === 'kidneyFailure' && <KidneyTarget />}

      <button>
        <FormattedMessage id="submit" />
      </button>
    </form>
  )
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      modifyGoals: fromGoal.editGoals
    },
    dispatch
  )
const mapStateToProps = (state, ownProps) => {
  const patient = getPatientFromMatch(state, ownProps.match)
  const goals = getGoalsFromPatientId(state, patient.id)

  return {
    patient,
    goals
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPatientGoals)



// WEBPACK FOOTER //
// ./src/Goal/containers/EditPatientGoals.js